import React from 'react';
import { Redirect } from 'react-router-dom';

const PageNotFoundRedirect = ({ notFoundRedirectUrl = '' }) => {
  return <Redirect to={notFoundRedirectUrl} />;
};

export default PageNotFoundRedirect;
